import { widgetActionType } from "../constants";
import Alert from "./Alert";
import Button from "./Button";
import Export from "./Export";
import DateFilter from "./DateFilter";
import DropDownFilter from "./DropDownFilter";

export const widgetActionTypeComponentMapper = {
  [widgetActionType.DATE_FILTER]: DateFilter,
  [widgetActionType.BUTTON]: Button,
  [widgetActionType.EXPORT]: Export,
  [widgetActionType.ALERT]: Alert,
  [widgetActionType.DROP_DOWN_FILTER]: DropDownFilter,
}